/* global axios */

import ApiClient from './ApiClient';

class CatalogAPI extends ApiClient {
  constructor() {
    super('catalog', { accountScoped: true });
  }

  getProductByExternalId(externalId, platform = null) {
    return axios.get(`${this.url}/products`, {
      params: {
        external_id: externalId,
        platform: platform || undefined,
        status: 'all',
      },
    });
  }

  getProducts({
    query = '',
    page = 1,
    sourceId = null,
    status = 'active',
    perPage = 20,
    sort = 'title',
    direction = 'asc',
  } = {}) {
    return axios.get(`${this.url}/products`, {
      params: {
        q: query || undefined,
        page,
        source_id: sourceId || undefined,
        status,
        per_page: perPage,
        sort,
        direction,
      },
    });
  }
}

export default new CatalogAPI();
